import React from 'react'

export default function TextSyntax({children}) {
	return (
        <span style={{color: "var(--shiki-color-text)"}}>
            {children}
		</span>
	)
}
